export default function isIphoneOrIpod() {
  return /iPhone|iPod/.test(navigator.userAgent);
}
